const APIs = {
  POSTS: 'admin/posts',
  SINGLE_POST: 'admin/posts/:id',
  PERFORM_ACTION_POST: 'admin/posts/:id/perform-action',
}

export default APIs
